import { useCallback } from 'react';
import type { AddressFieldEvent } from '../types';
import { EMPTY_ADDRESS_INFO } from '../types';
import type { DawaSuggestion } from './use-dawa-autocomplete';

const useAddressFieldEvents = (fieldEvent: AddressFieldEvent) => {
    const emitValid = useCallback(
        (eventType: 'select' | 'blur', suggestion: DawaSuggestion, kvhx: string | undefined) => {
            fieldEvent({
                address: suggestion.label,
                addressInfo: suggestion.addressInfo,
                status: 'valid',
                kvhx,
                kvhxUrl: suggestion.href,
                event: eventType,
            });
        },
        [fieldEvent]
    );

    const emitInvalid = useCallback(
        (eventType: 'blur' | 'reset', kvhx: string | undefined) => {
            fieldEvent({
                address: '',
                addressInfo: EMPTY_ADDRESS_INFO,
                status: 'invalid',
                kvhx,
                kvhxUrl: '',
                event: eventType,
            });
        },
        [fieldEvent]
    );

    const emitCustom = useCallback(
        (eventType: 'select' | 'blur', value: string) => {
            fieldEvent({
                address: value,
                addressInfo: EMPTY_ADDRESS_INFO,
                status: 'custom',
                kvhx: undefined,
                kvhxUrl: '',
                event: eventType,
            });
        },
        [fieldEvent]
    );

    return { emitValid, emitInvalid, emitCustom };
};

export { useAddressFieldEvents };
